namespace Matrix.Data {
    export interface DataReportsRow {
        Id?: number;
        ReportName?: string;
        ReportKey?: string;
        ReportDescription?: string;
        Category?: string;
        Permission?: string;
        QueryType?: DataQueryType;
        ObjectName?: string;
        DynamicSql?: string;
        ParameterList?: DataParameter[];
        Parameters?: string;
        ColumnList?: DataReportColumn[];
        PropertiesJson?: string;
        PropertiesObject?: DataReportProperties;
        Columns?: string;
        ExpandAllGroups?: number;
        FrozenColumns?: number;
        DisplayOrder?: number;
        IsActive?: number;
        IsVisible?: boolean;
        WorkbookHeight?: string;
        ShowWorkbookHomeTab?: number;
        ShowWorkbookViewTab?: number;
        ShowWorkbookReviewTab?: number;
        ShowWorkbookDataTab?: number;
        ShowWorkbookFormulasTab?: number;
        ShowWorkbookInsertTab?: number;
        ReadonlyWorkbook?: number;
        WorkbookFullScreenMode?: number;
    }

    export namespace DataReportsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ReportName';
        export const localTextPrefix = 'Data.DataReports';
        export const lookupKey = 'Data.DataReports';

        export function getLookup(): Q.Lookup<DataReportsRow> {
            return Q.getLookup<DataReportsRow>('Data.DataReports');
        }
        export const deletePermission = 'Administration:Reports';
        export const insertPermission = 'Administration:Reports';
        export const readPermission = 'Read:Reports';
        export const updatePermission = 'Administration:Reports';

        export declare const enum Fields {
            Id = "Id",
            ReportName = "ReportName",
            ReportKey = "ReportKey",
            ReportDescription = "ReportDescription",
            Category = "Category",
            Permission = "Permission",
            QueryType = "QueryType",
            ObjectName = "ObjectName",
            DynamicSql = "DynamicSql",
            ParameterList = "ParameterList",
            Parameters = "Parameters",
            ColumnList = "ColumnList",
            PropertiesJson = "PropertiesJson",
            PropertiesObject = "PropertiesObject",
            Columns = "Columns",
            ExpandAllGroups = "ExpandAllGroups",
            FrozenColumns = "FrozenColumns",
            DisplayOrder = "DisplayOrder",
            IsActive = "IsActive",
            IsVisible = "IsVisible",
            WorkbookHeight = "WorkbookHeight",
            ShowWorkbookHomeTab = "ShowWorkbookHomeTab",
            ShowWorkbookViewTab = "ShowWorkbookViewTab",
            ShowWorkbookReviewTab = "ShowWorkbookReviewTab",
            ShowWorkbookDataTab = "ShowWorkbookDataTab",
            ShowWorkbookFormulasTab = "ShowWorkbookFormulasTab",
            ShowWorkbookInsertTab = "ShowWorkbookInsertTab",
            ReadonlyWorkbook = "ReadonlyWorkbook",
            WorkbookFullScreenMode = "WorkbookFullScreenMode"
        }
    }
}
